export default __webpack_public_path__ + "static/media/113.ea10840e.jpg";